import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import {Observable} from 'rxjs/Observable';
import { PaymentMethod } from '../models/payment-method';

import 'rxjs/add/operator/map';

declare var Card: any;
declare var $;
declare var Payment: any;

@Injectable()
export class PaymentMethodHandler {
	observers: any = [];
	paymentMethodList: any;
 	paymentMethods: any = [];

	constructor(
		public storage: Storage
	){
		this.paymentMethodList = Observable.create(observer => {
		  this.observers.push(observer);
		});

		this.storage.get("paymentMethods").then((data: any)=>{
			if(data){
				this.paymentMethods = data
			}else{
				this.paymentMethods = []
			}
		});
	}

	getMethodById(id): any{
		var method = {};

		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
			if(this.paymentMethods[i].id == id){
				method = this.paymentMethods[i];
				break;
			}
		}

		return method;			
	}

	setCardType(nativeEl, cardNumber){
		var cardType = Payment.fns.cardType(cardNumber);

		console.log("CardType: " + cardType);

		var $jpCard = $(nativeEl).find(".jp-card");
		$jpCard.addClass("jp-card-identified");
		$jpCard.addClass("jp-card-" + cardType)
	}

	getLast4Digits(method){
		return method.number.substr(method.number.length - 4)
	}	

	getLastBlock(number){
		let arr = number.split(' ');

		return arr[arr.length-1]
	}		

	getCardIndex(number){
		var returnVal = 0;

		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
			if(this.paymentMethods[i].number == number){
				returnVal = i;
				break;
			}
		}

		return returnVal;	
	}	

	getCard(number){
		var card;

		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
			if(this.paymentMethods[i].number == number){
				card = this.paymentMethods[i];
				break;
			}
		}

		return card;	
	}		

	getDefaultMethod(){
		var method = {
			id: 0
		};

 		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
 			if(
 				this.paymentMethods[i].isDefault == true
 			){
 				method = this.paymentMethods[i];
 				break;
 			}
 		}				

 		return method;
	}

	setAllMethods(){
		this.storage.set('paymentMethods', this.paymentMethods);
	}

	methodShouldBeDefault(id){
		var returnVal = true;

 		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
 			if(
 				this.paymentMethods[i].id != id
 				&&
 				this.paymentMethods[i].isDefault == true
 			){
 				return false;
 			}
 		}		

 		return returnVal;		
	}

	removeDefaultFromOthers(id){
 		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
 			if(
 				this.paymentMethods[i].id != id
 			){
 				this.paymentMethods[i].isDefault = false;
 			}
 		}		

 		this.setAllMethods()
	}	

	methodIsUnique(method){
		var returnVal = true;

 		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
 			if(
 				this.paymentMethods[i].cardType == method.cardType
 				&&
 				this.paymentMethods[i].number == method.number
 				&&
 				this.paymentMethods[i].name == method.name			
 				&&
 				this.paymentMethods[i].id != method.id
 			){
 				return false;
 			}
 		}		

 		return returnVal;
	}

	maskNumber(number){
		let opts = {
			masks: {
				cardNumber: "*"	
			}
		};

		let maskedCardNumber = 
			(new Card(opts)).maskCardNumber(number, null, null);

		return maskedCardNumber;
	}

 	addPaymentMethod(method){
 		method.maskedNumber = this.maskNumber(method.number);
 		method.lastBlock = this.getLastBlock(method.number);

	    this.paymentMethods.push(method);

	    this.setAllMethods();
 	}

 	updatePaymentMethod(method){
 		method.maskedNumber = this.maskNumber(method.number);
 		method.lastBlock = this.getLastBlock(method.number);
 		
 		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
 			if(this.paymentMethods[i].id == method.id){
 				this.paymentMethods[i] = method
 			}
 		}
 		
 		this.setAllMethods();
 	} 	

	removeMethod(id){
 		for (var i = this.paymentMethods.length - 1; i >= 0; i--) {
 			if(
 				this.paymentMethods[i].id == id
 			){
 				this.paymentMethods.splice(i, 1)
 			}
 		}			

 		this.setAllMethods();
	}
}



// WEBPACK FOOTER //
// ./src/providers/payment-method-handler.ts